var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Title } from '@gerdau/hefesto';
import { Badge } from '../Badge';
import { Tag } from '../Tag';
import './NotificationCard.styles.scss';
var NotificationCard = function (_a) {
    var date = _a.date, description = _a.description, _b = _a.important, important = _b === void 0 ? false : _b, list = _a.list, onSeeDetailsClick = _a.onSeeDetailsClick, title = _a.title, viewed = _a.viewed;
    var formatDate = function (newDate) {
        var dateNotification = new Date(newDate);
        if (!dateNotification)
            return '';
        var dateNotificationDay = dateNotification.getDay();
        var dateNotificationMonth = dateNotification.getMonth();
        var dateNotificationYear = dateNotification.getFullYear();
        var today = new Date();
        var currentDay = today.getDay();
        var currentMonth = today.getMonth();
        var currentYear = today.getFullYear();
        if (currentYear !== dateNotificationYear) {
            var options = {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit',
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            };
            return dateNotification.toLocaleDateString('pt-BR', options);
        }
        if (currentMonth !== dateNotificationMonth ||
            currentDay !== dateNotificationDay) {
            var options = {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit',
                month: '2-digit',
                day: '2-digit',
            };
            return dateNotification.toLocaleDateString('pt-BR', options);
        }
        return "Hoje, ".concat(dateNotification.getHours(), ":").concat(dateNotification.getMinutes());
    };
    return (_jsx(Card, { children: _jsxs("div", __assign({ className: "hefesto-notification-card" }, { children: [_jsxs("div", __assign({ className: "hefesto-notification-card__header" }, { children: [_jsxs("div", __assign({ className: "hefesto-notification-card__header-title" }, { children: [!viewed && _jsx(Badge, { type: "indicator" }), _jsx(Title, __assign({ level: 5 }, { children: title }))] })), _jsx("div", __assign({ className: "hefesto-notification-card__header-important" }, { children: important && _jsx(Tag, __assign({ variant: "info" }, { children: "Importante" })) })), date && (_jsx("div", __assign({ className: "hefesto-notification-card__header-date" }, { children: _jsx("span", __assign({ "aria-label": "data da notifica\u00E7\u00E3o", role: "text" }, { children: formatDate(date) })) })))] })), _jsxs("div", __assign({ className: "hefesto-notification-card__body" }, { children: [!!description && (_jsx("p", __assign({ className: "description", role: "presentation" }, { children: description }))), !!list &&
                            list.map(function (item, idx) { return (_jsxs("p", __assign({ role: "presentation" }, { children: [_jsx("span", __assign({ className: "title", "aria-label": "titulo do item", role: "text" }, { children: item.title })), item.date && (_jsx("span", __assign({ className: "date", "aria-label": "data do item", role: "text" }, { children: formatDate(item.date) })))] }), idx)); })] })), _jsx("div", __assign({ className: "hefesto-notification-card__footer" }, { children: onSeeDetailsClick && (_jsx(Button, __assign({ name: "seeMore", onClick: onSeeDetailsClick, variant: "tertiary" }, { children: "Ver detalhes" }))) }))] })) }));
};
export default NotificationCard;
